export default __webpack_public_path__ + "static/media/plan_linkage_view.44874a9a.png";